/**
 * Sin Sede Utilities
 * Filters out records with no valid sede from chart data.
 * Per requirement: if a record has no sede, exclude from charts and show disclaimer.
 */

const SIN_SEDE_PATTERNS = [
  '', 'sin sede', 'sin_sede', 'sin definir', 'sin_definir',
  'n/a', '-', 'null', 'undefined', 'no definido', 'no definida',
  'sin asignar', 'no asignado', 'no asignada',
];

/**
 * Check if a sede value is effectively "without sede".
 * @param {string|null|undefined} sedeValue
 * @returns {boolean}
 */
export function isSinSede(sedeValue) {
  if (sedeValue === null || sedeValue === undefined) return true;
  const normalized = String(sedeValue).trim().toLowerCase();
  return SIN_SEDE_PATTERNS.includes(normalized) || normalized.startsWith('sin sede');
}

/**
 * Filter a data array, separating valid sede records from "sin sede" records.
 * @param {Array} data - array of chart data objects
 * @param {string} sedeField - key in each item that holds the sede value (default: 'sede')
 * @param {string} countField - key in each item that holds the count value (default: 'total')
 * @returns {{ valid: Array, sinSedeCount: number }}
 */
export function filterSinSede(data, sedeField = 'sede', countField = 'total') {
  if (!Array.isArray(data)) return { valid: [], sinSedeCount: 0 };

  const valid = [];
  let sinSedeCount = 0;

  for (const item of data) {
    if (isSinSede(item[sedeField])) {
      sinSedeCount += (item[countField] || 1);
    } else {
      valid.push(item);
    }
  }

  return { valid, sinSedeCount };
}

/**
 * SinSedeDisclaimer component props helper.
 * Returns the text to show at the bottom of a chart.
 */
export function sinSedeDisclaimer(count) {
  if (!count) return null;
  return `*Sin sede: ${count.toLocaleString('es-ES')} registro${count === 1 ? '' : 's'} excluido${count === 1 ? '' : 's'} del gráfico por no tener sede asignada.`;
}
